import { gql } from "@apollo/client"
import { useMutation } from "@oysterhr/core"
import { MutationVerifyAgreementArgs, VerifyAgreementPayload } from "@oysterhr/schema"
import { CustomerProcessHighwayFragment } from "~/shared/fragments/CustomerProcessHighwayFragment"
import { AgreementDetailsFragment } from "../fragments/AgreementDetailsFragment"

const VerifyAgreementMutation = gql`
  mutation VerifyAgreement($input: VerifyAgreementInput!) {
    verifyAgreement(input: $input) {
      employment {
        id
        invitation {
          sentAt
        }
        hiring {
          banners
          id
          agreements {
            ...AgreementDetails
          }
          envelopes {
            id
            automationState
            isUpdateNeeded
          }
          ...CustomerProcessHighway
        }
      }
      engagement {
        id
        termination {
          id
          agreements {
            ...AgreementDetails
          }
        }
      }
      errors
    }
  }
  ${CustomerProcessHighwayFragment}
  ${AgreementDetailsFragment}
`

export const useVerifyAgreement = () => {
  return useMutation<{ verifyAgreement: VerifyAgreementPayload }, MutationVerifyAgreementArgs>(
    VerifyAgreementMutation,
  )
}
